/**
 * Emit hosts for the `past-context` analytics group — 3 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  type ContextLinkedEventProps,
  type ContextPreviewedEventProps,
  type ContextUnlinkedEventProps,
} from '@/models/analytics/features/past-context';

export function trackContextLinked(input: ContextLinkedEventProps) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ContextLinked,
    props: input,
  });
}

// Context (Previous Notes/Sessions linked to current session)
export function trackContextPreviewed(input: ContextPreviewedEventProps) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ContextPreviewed,
    props: input,
  });
}

export function trackContextUnlinked(input: ContextUnlinkedEventProps) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ContextUnlinked,
    props: input,
  });
}
